angular.module('nv.singleStudent').component('studentRegentsPanel', {
  template: require('./student-regents-panel.html'),
  bindings: {
    student: '<',
    school: '<',
    studentSupports: '<',
    isRestricted: '<',
    saveStudent: '&',
  },
  controller: 'StudentRegentsPanelCtrl',
});
